const getters = {
  selectedOrder: state => {
    return state.order ? state.order : null
  },
}

export default getters
